import api from 'api';

const url = id => `/api/payments/${id}/revalidate`;

export default {
    get: id => api.get({path: url(id)}),
}